var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { toast } from 'react-toastify';
import { ReminderModal } from '@ReactComponents/TransactionsPage/TransactionsModals/ReminderModal';
import { SplitApi } from '@ClientApi/split';
import { TransactionsApi } from '@ClientApi/transactionsApi';
import { ShowModal } from './modalActions';
export const SET_TRANSACTIONS_LOADING = 'SET_TRANSACTIONS_LOADING';
export const RESET_TRANSACTIONS_LOADED_TIMESTAMP = 'RESET_TRANSACTIONS_LOADED_TIMESTAMP';
export const RESET_TRANSACTIONS_UPDATED_TIMESTAMP = 'RESET_TRANSACTIONS_UPDATED_TIMESTAMP';
export const RESET_TRANSACTIONS = 'RESET_TRANSACTIONS';
export const SELECT_TRANSACTION = 'SELECT_TRANSACTION';
export const CLEAR_SELECTED_TRANSACTION = 'CLEAR_SELECTED_TRANSACTION';
export const SET_ACCOUNTING_TRANSACTIONS_COUNT = 'SET_ACCOUNTING_TRANSACTIONS_COUNT';
export class SetTransactionsLoading {
    constructor(payload) {
        this.payload = payload;
        this.type = SET_TRANSACTIONS_LOADING;
    }
}
export class ResetTransactionsLoadedTimestamp {
    constructor() {
        this.type = RESET_TRANSACTIONS_LOADED_TIMESTAMP;
    }
}
export class ResetTransactionsUpdatedTimestamp {
    constructor() {
        this.type = RESET_TRANSACTIONS_UPDATED_TIMESTAMP;
    }
}
export class ResetTransactions {
    constructor() {
        this.type = RESET_TRANSACTIONS;
    }
}
export class SelectTransaction {
    constructor(payload) {
        this.payload = payload;
        this.type = SELECT_TRANSACTION;
    }
}
export class ClearSelectedTransaction {
    constructor() {
        this.type = CLEAR_SELECTED_TRANSACTION;
    }
}
export class SetAccountingTransactionsCount {
    constructor(payload) {
        this.payload = payload;
        this.type = SET_ACCOUNTING_TRANSACTIONS_COUNT;
    }
}
/**
 * Remove params from sections that don't support them
 *
 * @param {string} section
 * @param {ISearchTransactionsParams} params
 * @return {*}
 */
export function sanitizeSearchParams(section, params) {
    const sanitizedParams = Object.assign({}, params);
    sanitizedParams.filters = Object.assign({}, params.filters);
    if (section !== 'pending') {
        delete sanitizedParams.filters.status;
    }
    return sanitizedParams;
}
export const approveTransaction = (expense) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    yield TransactionsApi.approve(expense.id);
});
export const denyTransaction = (expense, data) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    yield TransactionsApi.deny(expense.id, data);
});
export const skipTransaction = (expense) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    yield TransactionsApi.skip(expense);
});
export const clearSelectedTransaction = () => (dispatch) => {
    dispatch(new ClearSelectedTransaction());
};
export const unapproveTransaction = (expense, data) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    yield TransactionsApi.unapprove(expense.id, data);
});
export const deleteTransaction = (expense) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    if (expense.split_transaction_id) {
        yield SplitApi.deleteSplits(expense.split_transaction_id);
    }
    else {
        yield TransactionsApi.deleteOne(expense.id);
    }
});
export const queueTransaction = (payload) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        yield TransactionsApi.queueWithoutToastWrapper(payload);
    }
    catch (error) {
        const data = JSON.parse(error.message);
        toast.error(data.error);
    }
});
export const submitTransaction = (payload) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        yield TransactionsApi.submitWithoutToastWrapper(payload);
    }
    catch (error) {
        const data = JSON.parse(error.message);
        toast.error(data.error);
    }
});
export const openReminderModal = (userId) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch(new ShowModal(ReminderModal, {
        onSuccessfulReminder: () => { },
        userId
    }));
});
export const unskipTransaction = (expense) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    yield TransactionsApi.unskip(expense);
});
